<template>
  <div>
    <iModal title="置顶" v-model="showModal" class-name="vertical-center-modal" width="500px" :mask-closable="false" @on-cancel="cancel">
      <div class="admin-add">
        <div class="admin-add-content">
          <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="right" :label-width="100" @submit.native.prevent>
            <FormItem label="置顶类型：" prop="type">
              <Select v-model="formInline.type" style="width:300px" placeholder="请选择置顶类型">
                <Option v-for="item in typeList" :value="item.value" :key="item.label" @click.native="select(item)">{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem label="置顶时间：" prop="time">
              <DatePicker type="daterange" placeholder="选择置顶时间" style="width: 300px" v-model="time"></DatePicker>
            </FormItem>
            <FormItem label="置顶排序：" prop="time">
              <InputNumber v-model="formInline.showIndex"></InputNumber>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit()">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
let moment = require("moment");
import { mapActions } from "vuex";

export default {
  name: "ex-to-top",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    editInfo: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false,
      showModal: true,
      time: [],
      formInline: {
        showIndex: 0,
        type: 0 // "0:不置顶（时间可以不填），1：置顶
      },
      typeList: [
        {
          value: 0,
          label: "不置顶"
        },
        {
          value: 1,
          label: "置顶"
        }
      ],
      ruleInline: {
        type: [{ required: true, message: "置顶类型不能为空", trigger: "blur" }]
      }
    };
  },
  watch: {
    show (val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
  },
  created () {
    let info = this.editInfo;
    if (info) {
      this.formInline.type = info.isTopping;
      this.formInline.showIndex = info.toppingIndex;
      if (info.toppingStartTime) {
        this.time[0] = info.toppingStartTime;
      }
      if (info.toppingEndTime) {
        this.time[1] = info.toppingEndTime;
      }
    }
  },
  methods: {
    ...mapActions({
      setToTop: "hostSetModule/setToTop"
    }),
    async handleSubmit (name) {
      const type = this.formInline.type;
      let start = "";
      let end = "";
      if (type !== 0 && !this.time[0]) {
        this.$Message.error("请选择置顶时间");
        return;
      }
      if (this.time && this.time[0]) {
        start = moment(this.time[0]).format("YYYY-MM-DD");
      }
      if (this.time && this.time[1]) {
        end = moment(this.time[1]).format("YYYY-MM-DD");
      }

      let req = {
        Id: this.editInfo.joinId,
        isTopping: type,
        toppingStartTime: start,
        toppingEndTime: end,
        toppingIndex: this.formInline.showIndex
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let bool = await this.setToTop(req).catch(err => {
        this.loading = false;
      });
      if (!bool) {
        this.loading = false;
        this.$Message.error("操作失败，请重新尝试");
      } else {
        this.$emit("finish");
        this.$Message.success("操作成功！");
        this.cancel();
      }
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel () {
      this.$refs["formInline"].resetFields();
      this.$emit("close");
    },
    select (item) {
      if (item.value == 0) {
        this.time = [];
      }
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
/deep/ .admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

